"use strict";

exports.__esModule = true;
exports.ScheduleStartTimeField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _libTimeline = require("@vimana/lib-timeline");
var _Core = require("../../Core");
var _Time = require("../../Time");
var _CalendarContext = require("../CalendarContext");
var _timeDefinitions = require("../../timeDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ScheduleStartTimeField = exports.ScheduleStartTimeField = function ScheduleStartTimeField() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_CalendarContext.CalendarContext),
    calendar = _React$useContext2.calendar;
  var now = Date.now();
  var earliestStartDate = Math.max.apply(Math, [now + _timeDefinitions.DAY_IN_MILLIS].concat(calendar.schedules.filter(function (schedule) {
    return schedule.interval.startMillis > now;
  }).map(function (schedule) {
    return schedule.interval.startMillis;
  })));
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: "interval.startMillis"
  }, function (_ref) {
    var input = _ref.input,
      meta = _ref.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.touched && meta.error ? "danger" : "secondary",
      helperText: meta.touched && meta.error ? meta.error : translate("ScheduleStartTimeField.helperText", "The date / time this schedule is valid from."),
      label: translate("ScheduleStartTimeField.label", "Valid From"),
      labelFor: "interval.startMillis",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement(_Time.TimestampSelector, {
      datePickerProps: {
        minDate: new Date(earliestStartDate),
        maxDate: new Date(_libTimeline.END_OF_TIME)
      },
      selected: [new Date(input.value)],
      onSelect: function onSelect(_ref2) {
        var value = _ref2[0];
        return value && input.onChange(value.getTime());
      }
    }));
  });
};